const DEFAULT_API_URL = 'https://api.daater.co';

export const normalizeApiUrl = (value?: string | null): string => {
  const trimmed = value?.trim();
  if (!trimmed) return DEFAULT_API_URL;

  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`.replace(/\/+$/, '');
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed.replace(/\/+$/, '');
  }

  return `https://${trimmed}`.replace(/\/+$/, '');
};

export const getApiUrl = (): string => {
  return normalizeApiUrl(import.meta.env.VITE_API_URL);
};
